var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 62,
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30.6034,
    cy: 30.8485,
    r: 30.5741,
    fill: "#4C4D52"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.3624 37.4787C42.4698 36.5795 40.3082 35.2673 39.2595 34.7384C37.8937 34.0505 37.7813 33.9943 36.7078 34.7918C35.9918 35.324 35.5157 35.7995 34.6777 35.6208C33.8398 35.4421 32.0187 34.4344 30.4242 32.8451C28.8297 31.2557 27.7636 29.382 27.5843 28.5469C27.405 27.7117 27.8883 27.2414 28.4155 26.5237C29.1585 25.5121 29.1023 25.3435 28.4672 23.9778C27.9721 22.9156 26.6215 20.7744 25.7189 19.8865C24.7533 18.9327 24.7533 19.1013 24.1311 19.3599C23.6246 19.573 23.1386 19.832 22.6794 20.1337C21.7801 20.7311 21.281 21.2274 20.932 21.9732C20.583 22.7189 20.4262 24.4673 22.2286 27.7415C24.0311 31.0157 25.2957 32.6899 27.9131 35.2999C30.5305 37.9098 32.5431 39.3131 35.4854 40.9631C39.1252 43.0015 40.5213 42.6042 41.2693 42.2557C42.0174 41.9073 42.5159 41.4127 43.1145 40.5135C43.417 40.0551 43.6767 39.5697 43.8901 39.0636C44.1492 38.4437 44.3178 38.4437 43.3624 37.4787Z",
    stroke: "#33B1E9",
    strokeWidth: 1.79848,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/Icon.7e0367d1fc7d5bfb1287946f2efb11d1.svg";
export { ForwardRef as ReactComponent };